import { jsxs as c, Fragment as o, jsx as e } from "react/jsx-runtime";
import { getPriceString as S } from "../../../services/strings/index.js";
import { DealStampOff as m, DealStampContainer as v } from "./style.js";
import { useTranslation as x } from "../../../hooks/useTranslation/index.js";
function j({
  className: p,
  deal: s,
  inactive: d,
  parentElement: h,
  position: f,
  ...u
}) {
  const { t } = x("common");
  let n;
  const g = { "--stamp-position": f }, { discountFixed: a, discountPercentage: l, freeShipping: F, price: r } = s || {};
  if (a) {
    const i = Math.ceil(a);
    n = /* @__PURE__ */ c(o, { children: [
      /* @__PURE__ */ e("small", { children: t("deal-stamp-currency") }),
      /* @__PURE__ */ e("span", { children: i }),
      /* @__PURE__ */ e(m, { children: /* @__PURE__ */ e("small", { children: " OFF" }) })
    ] });
  }
  if (l) {
    const i = Math.ceil(l);
    n = /* @__PURE__ */ c(m, { children: [
      i,
      "%",
      /* @__PURE__ */ e("small", { children: " OFF" })
    ] });
  }
  if (r) {
    const i = S(r);
    n = /* @__PURE__ */ c(o, { children: [
      /* @__PURE__ */ e("small", { children: t("deal-stamp-currency") }),
      /* @__PURE__ */ e("span", { children: i })
    ] });
  }
  return !a && !l && !r && (n = /* @__PURE__ */ e("span", { children: t("deal-stamp-free") })), F && (n = /* @__PURE__ */ e("span", { children: t("deal-stamp-free-shipping") })), s || (n = null), /* @__PURE__ */ e(
    v,
    {
      as: h,
      "data-testid": "deal-stamp",
      className: p,
      $inactive: d,
      ...u,
      style: g,
      children: n
    }
  );
}
export {
  j as DealStamp
};
